import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { UndoRedoChange } from "event-definitions"
import { Box, Divider, IconButton, Tooltip } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function Undo() {
    const { editMode, redo, canRedo, canUndo, undo } = useBoundContext()
    UndoRedoChange.useRefresh()
    return (
        !!editMode &&
        !!canUndo &&
        !!canRedo && (
            <>
                <Box sx={{ lineHeight: 0 }} mr={1} data-cy="undo-redo-buttons">
                    <Tooltip title="Undo">
                        <span>
                            <IconButton
                                aria-label="Undo"
                                size="small"
                                onClick={undo}
                                color="primary"
                                disabled={!canUndo()}
                                data-cy="undo-button"
                            >
                                <Iconify icon="mdi:undo" />
                            </IconButton>
                        </span>
                    </Tooltip>
                    <Tooltip title="Redo">
                        <span>
                            <IconButton
                                aria-label="Redo"
                                size="small"
                                onClick={redo}
                                color="primary"
                                disabled={!canRedo()}
                                data-cy="redo-button"
                            >
                                <Iconify icon="mdi:redo" />
                            </IconButton>
                        </span>
                    </Tooltip>
                </Box>
                <Divider orientation="vertical" flexItem />
            </>
        )
    )
}
